import { parse, format } from 'date-fns';
const isValidMail = (email) => {
    return (/^[a-z0-9.]+@[a-z0-9]+\.[a-z]+\.([a-z]+)?$/i.test(email) ||
        /^[a-z0-9.]+@[a-z0-9]+\.([a-z]+)?$/i.test(email));
};
const getTime = (time, type) => {
    const dateInterface = 'dd/MM/yyyy HH:mm';
    const utc = parse(time, dateInterface, new Date());
    const formattedDate = format(utc, dateInterface);
    if (type === 'date') {
        const regexData = /\b(\d{2}\/\d{2}\/\d{4})\b/;
        return formattedDate.match(regexData)?.[1];
    }
    else {
        const regexTime = /\b(\d{2}:\d{2})\b/;
        return formattedDate.match(regexTime)?.[1];
    }
};
const dateFormatter = (date, isDashed) => {
    return format(new Date(isDashed ? date.replace(/-/g, '/') : date), 'dd/MM/yyyy');
};
export const moneyFormater = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
});
const removesSpecialCharacters = (text) => text.replace(/[^a-zA-Z0-9 ]/g, '');
const translateRegion = (region) => {
    if (!region)
        return null;
    if (region.toLowerCase() === 'se')
        return 'SUDESTE';
    if (region.toLowerCase() === 'so')
        return 'SUL';
    if (region.toLowerCase() === 'ne')
        return 'NORDESTE';
    if (region.toLowerCase() === 'no')
        return 'NORTE';
    if (region.toLowerCase() === 'cw')
        return 'CENTRO-OESTE';
    return region;
};
const getNum = (value) => {
    return value || 0;
};
export const months = [
    '',
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
];
const getMonth = (index) => months[index];
const getExtension = (fileName) => {
    const regex = /data:image\/(\w+);base64/;
    const separatedFile = fileName.toLowerCase().match(regex);
    if (separatedFile)
        return '.' + separatedFile[1];
    return '.jpg';
};
export { getExtension, isValidMail, dateFormatter, removesSpecialCharacters, translateRegion, getNum, getMonth, getTime, };
